<script setup lang="ts">
const defaultStyling = 'w-5/6 text-2xl font-bold text-gray-900'
</script>

<template>
  <Container
    class="flex border-spacing-3 flex-col items-center justify-center border-b border-gray-200 bg-gray-50 py-24"
  >
    <Heading as="h2" class="mb-8" size="caption">{{ $t('healthcare.more_section.eyebrow') }}</Heading>

    <Heading as="h3" size="large">{{ $t('healthcare.more_section.title') }}</Heading>
    <Heading as="h3" class="text-main-600" size="large">{{ $t('healthcare.more_section.sub_title') }}</Heading>

    <Paragraph class="mt-8 w-[90%] text-center lg:w-[40%]" as="p">{{ $t('healthcare.more_section.body') }}</Paragraph>

    <Action class="mt-32" intent="main" size="lg" as="link" to="/contact">{{ $t('header.nav.contact') }}</Action>
  </Container>
</template>
